import { createTheme, responsiveFontSizes } from "@mui/material/styles";

import palette from "./palette";
import shadows from "./shadows";

const getTheme = (mode, paletteType) =>
	responsiveFontSizes(
		createTheme({
			palette: palette(mode, paletteType),
			shadows: shadows(mode),
			typography: {
				fontFamily: '"Inter", sans-serif',
				button: {
					textTransform: "none",
					fontWeight: "medium",
				},
			},
			zIndex: {
				appBar: 1200,
				drawer: 1300,
			},
			// @ts-expect-error
			components: {
				MuiButton: {
					styleOverrides: {
						containedSecondary: mode === "light" ? { color: "white" } : {},
					},
				},
			},
		}),
	);

export default getTheme;
